import { useTranslation } from "react-i18next";
import ISO_639_LANGUAGES from "../../../data/iso639Languages";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language || "en";

  const change = (code) => i18n.changeLanguage(code);

  return (
    <div className={compact ? "w-full" : "inline-flex items-center gap-2"} data-testid="language-switcher">
      <select
        value={current}
        onChange={(e) => change(e.target.value)}
        className="w-full border border-[#E7E6E2] rounded-lg px-2.5 py-2 text-sm bg-[#FAFAFA] text-[#111] cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#6D3FE0]"
        data-testid="language-select"
      >
        {ISO_639_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            {l.code.toUpperCase()} — {l.name}
          </option>
        ))}
      </select>
    </div>
  );
}
